export enum LossType {
  Absolute = 0,
  Percentage = 1
}